import { Role } from '@personal-area/global/users/models';
import { CertificateModel } from './certificate.model';

import { AccountMetricsDTO } from './metrics';

export class TradingAccount {
  server: string;
  tariff: string;
  leverage: number;
  currency: string;
  role: string;
  amount: number;
  amountCurrency: string;
  isSwapFreeEnabled: boolean;
  creationKey: string;
  public constructor(init?: Partial<TradingAccount>) {
    Object.assign(this, init);
  }
}

/**
 * Promo account type.
 */
export class PromoAccount {
  server: string;
  tariff: string;
  leverage: number;
  currency: string;
  role: string;
  amount: number;
  amountCurrency: string;

  public constructor(init?: Partial<PromoAccount>) {
    Object.assign(this, init);
  }
}

interface FixRateParams {
  currencyFrom: string;
  currencyTo: string;
  id: number;
  rate: number;
}

export interface AccountExtras {
  equity?: number;
  hasDeposit: boolean;
  isExpertsAvailable: boolean;
  isSwapFree: boolean;
  lastDepositAmount: number;
  lastDepositId: number;
  mtStatus: string;
  server: {
    address: string;
    name: string;
    type: 'mt4' | 'mt5';
  };
}

export enum AccountStatus {
  active = 'active',
  archived = 'archived',
  deleted = 'deleted',
  restoring = 'restoring'
}

export interface AccountsResponse {
  list: AccountDTO[],
  primaryAccountId: number
}

export interface AccountDTO {
  id: number;
  userId: number;
  tariff: AccountTariff;
  currency: string;
  actions: AccountPermissions[];
  name: string;
  userComment: string;
  balanceMultiplier: number;
  bonusClosedAt: string;
  comment: string;
  createdAt: string;
  fixRate: FixRateParams;
  group: string;
  isBonus: boolean;
  isDemo: boolean;
  isEnabled: boolean;
  isFixRate: boolean;
  isInsured: boolean;
  isHasTrades: boolean;
  leverage: number;
  linkedAccountId: number;
  login: number;
  maxWithdrawAmount: number;
  mtSync: boolean;
  partnerId: number;
  partnerLogin: number;
  partnerUnlinkedAt: string;
  serverId: number;
  sort: number;
  status: AccountStatus;
  type: Role;
  updatedAt: string;
  extras?: AccountExtras;
  logo: string;
}

// front-end only
export interface Account extends AccountDTO, AccountMetricsDTO {
  daysLeft: number; // for promo
  balanceFixed: number;
}

export enum AccountPermissions {
  blanceOperation = 'blanceOperation',
  deposit = 'deposit',
  withdrawal = 'withdrawal',
  internalIn = 'internalIn',
  balanceOperation = 'balanceOperation',
  changeLeverage = 'changeLeverage',
  internalOut = 'internalOut',
  internalAutoOut = 'internalAutoOut',
  partnerIn = 'partnerIn',
  clientOut = 'clientOut',
  insurance = 'insurance',
  swapFree = 'swapFree',
  autoWithdrawal = 'autoWithdrawal',
  aLotOfApples = 'aLotOfApples',
  transfer = 'transfer',
  canDepositPsBonus = 'canDepositPsBonus',
  bonus123CalcLots = 'bonus123CalcLots',
  partnerBonusCalcLots = 'partnerBonusCalcLots',
  applyMarginBonus = 'applyMarginBonus',
  becomeControl = 'becomeControl', // account can be published to CopyTrade
  performControl = 'performControl', // account is eligible for CopyTrade publish (balance => 100 USD)
  canControl = 'canControl' // account is published to CopyTrade
}

export interface AccountCertificate extends CertificateModel {
  serverName: string;
  serverAddress: string;
  serverType: string;
}

export enum AccountTariff {
  cent = 'cent',
  demoCent = 'demoCent',
  stand = 'stand',
  demoStand = 'demoStand',
  unlim = 'unlim',
  micro = 'micro',
  demoMicro = 'demoMicro',
  ecn = 'ecn',
  demoEcn = 'demoEcn',
  segreg = 'segreg',
  zero = 'zero',
  demoZero = 'demoZero',
  partner = 'partnersw',
  exchanger = 'exchanger',
  ramadan = 'ramadan',
  ramadanReal = 'ramadanReal',
  seccent = 'seccent',
  secstand = 'secstand',
  seccentPro = 'seccentPro',
  secstandPro = 'secstandPro',
  demoSecCentPro = 'demoSecCentPro',
  demoSecStandPro = 'demoSecStandPro',
  crypto = 'crypto',
  demoCrypto = 'demoCrypto',
  tpStand = 'tp',
  demoTp = 'demoTp',
  tpCrypto = 'tpCrypto',
  tpDemoCrypto = 'demoTpCrypto',
  professional = 'professional',
  demoProfessional = 'demoProfessional'
}

export interface CreateAccountResponse {
  hasCertificate?: boolean;
  id: number | string;
}

export const TPAccountTariffs =
  [AccountTariff.tpStand, AccountTariff.demoTp, AccountTariff.tpCrypto, AccountTariff.tpDemoCrypto];

export const TPTariffsMap = new Map([
  [AccountTariff.tpStand, AccountTariff.stand],
  [AccountTariff.demoTp, AccountTariff.demoStand],
  [AccountTariff.tpCrypto, AccountTariff.crypto],
  [AccountTariff.tpDemoCrypto, AccountTariff.demoCrypto],
]);
